const state = {
  visitedViews: [],
  cachedViews: [],
  sysBelong: "",
  nowClickActionType: "close", // 切换路由时，做是否重载页面判断
  hideCloseTags: [], // 非当前页面关闭，缓存会有问题，所有进行记录
  favTopShow: localStorage.getItem("favTopShow") || "", // 顶部收藏菜单 显示隐藏控制
  canGetSonAppInfo: true // 用于解决，标签来回跳舞的bug,做基座接受子应用router的间隔方法
}

const mutations = {
  ADD_HIDE_CLOSE_TAGS: (state, view) => {
    const haveIt = state.hideCloseTags.filter(v => v.fullPath === view.fullPath)
    if (haveIt.length === 0) {
      state.hideCloseTags.push(view)
    }
  },
  UPDATE_HIDE_CLOSE_TAGS: (state, arr) => {
    state.hideCloseTags = arr
  },
  CHANGE_TITLE: (state, view) => {
    state.visitedViews.forEach(v => {
      if (v.fullPath.split("#")[1] === view.fullPath) {
        v.title = view.newTitle
      }
    })
  },
  CHANGE_FAVTOPSHOW: (state, val) => {
    state.favTopShow = val
    localStorage.setItem("favTopShow", val)
  },
  ADD_VISITED_VIEW: (state, view) => {
    // 存下归属那个菜单的标识，因为会有同一个菜单，出现在2个中心菜单中，为了避免同样的菜单点击后，左侧菜单跳走的问题
    state.sysBelong = view.sysBelong
    // 匹配下，如果跳转到同一个页面，更新标签的fullPath（比如详情页等）
    state.visitedViews.forEach(v => {
      if (v.fullPath.split("?")[0] === view.fullPath.split("?")[0]) {
        v.fullPath = view.fullPath
      }
    })
    if (state.visitedViews.some(v => v.fullPath.split("?")[0] === view.fullPath.split("?")[0])) return
    if (view.meta && view.meta.tagHide) {
      return
    }
    try {
      // 跳转的页面与本地菜单匹配，找到对应菜单，进行数据添加
      if (view.meta && view.meta.title) {
        state.visitedViews.push(
          Object.assign({}, view, {
            title: view.meta.title
          })
        )
      }
    } catch (e) {
      console.log(e)
    }
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (!state.cachedViews.includes(view.name)) {
      state.cachedViews.push(view.name)
      if (view.pathName) {
        state.cachedViews.push(view.pathName)
      }
      // 还原标签关闭状态
      state.nowClickActionType = ""
    }
    if (view.meta && !view.meta.noCache) {
      // 如果是嵌套路由，需要将父级路由加入到缓存
      if (view.meta.parent) {
        if (!state.cachedViews.includes(view.meta.parent)) {
          state.cachedViews.push(view.meta.parent)
        }
      }
    }
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.fullPath === view.fullPath) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.pathName)
    index > -1 && state.cachedViews.splice(index, 1)
    const index2 = state.cachedViews.indexOf(view.name)
    index2 > -1 && state.cachedViews.splice(index2, 1)
    // 如果meta里有些父页面的name名字，那么在关闭时也进行删除
    if (view.meta && view.meta.parent) {
      const p_index = state.cachedViews.indexOf(view.meta.parent)
      p_index > -1 && state.cachedViews.splice(p_index, 1)
    }
  },

  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    state.visitedViews = state.visitedViews.filter(v => {
      return v.meta.affix || v.path === view.path
    })
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
  },

  DEL_ALL_VISITED_VIEWS: state => {
    // keep affix tags
    const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
    state.visitedViews = affixTags
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = []
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },
  UPDATE_CanGetSonAppInfo: (state, view) => {
    state.canGetSonAppInfo = view
  }
}

const actions = {
  addHideCloseTags({ commit }, view) {
    commit("ADD_HIDE_CLOSE_TAGS", view)
  },
  updateHideCloseTags({ commit }, arr) {
    commit("UPDATE_HIDE_CLOSE_TAGS", arr)
  },
  addView({ dispatch }, view) {
    // 更新title
    if (view.meta) {
      document.title = view.meta.title
    }
    dispatch("addVisitedView", view)
    dispatch("addCachedView", view)
  },
  addVisitedView({ commit }, view) {
    commit("ADD_VISITED_VIEW", view)
  },
  addCachedView({ commit }, view) {
    commit("ADD_CACHED_VIEW", view)
  },
  changeNowClickActionType({ commit }, type) {
    state.nowClickActionType = type
  },
  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      // 记录当前点击关闭操作
      dispatch("changeNowClickActionType", "close")
      dispatch("delVisitedView", view)
      dispatch("delCachedView", view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit("DEL_VISITED_VIEW", view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit("DEL_CACHED_VIEW", view)
      resolve([...state.cachedViews])
    })
  },

  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch("delOthersVisitedViews", view)
      dispatch("delOthersCachedViews", view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit("DEL_OTHERS_VISITED_VIEWS", view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit("DEL_OTHERS_CACHED_VIEWS", view)
      resolve([...state.cachedViews])
    })
  },

  delAllViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch("delAllVisitedViews", view)
      dispatch("delAllCachedViews", view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit("DEL_ALL_VISITED_VIEWS")
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit("DEL_ALL_CACHED_VIEWS")
      resolve([...state.cachedViews])
    })
  },

  updateVisitedView({ commit }, view) {
    commit("UPDATE_VISITED_VIEW", view)
  },
  updateCanGetSonAppInfo({ commit }, view) {
    commit("UPDATE_CanGetSonAppInfo", view)
  },
  changeTitle({ commit }, view) {
    commit("CHANGE_TITLE", view)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
